enum StealMapType {
  Leaflet = "leaflet",
  Mapkit = "mapkit",
  Mapbox = "mapbox",
  Google = "google"
}

export default StealMapType;
